<template>
	<div>

	</div>
</template>

<script>
	export default {
		name:'index',
		data() {
			return {

			}
		},
		created() {
			var that=this;
			that.getquery();
		},
		methods: {
			getquery(){
			var that=this;
			var formdata={

			};
			that.postFn(that.$apis.querylogindict, formdata,(res)=>{
			var data=JSON.parse(res.body.data)
			// console.log(data);
			sessionStorage.setItem('querydict',JSON.stringify(data));
			
			})	
			},
		}
	}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/index.vue